import { createGlobalStyle } from "styled-components";

/** React Flow library class hooks (cannot be component-scoped). */
export const XyFlowStyles = createGlobalStyle`
  .react-flow {
    --xy-controls-button-background-color-default: #fbfcfb;
    --xy-controls-button-color-default: #3e5548;
    --xy-controls-button-border-color-default: #dce2dd;
  }
  .react-flow__node-system {
    width: 276px;
    z-index: 1 !important;
    border-radius: 10px;
  }
  .react-flow__node-context {
    width: 78px;
    height: 61px;
    z-index: 6 !important;
  }
  .react-flow__edge-textbg {
    filter: drop-shadow(0 1px 1px rgba(35, 53, 44, 0.08));
  }
  .react-flow__edge.selected .react-flow__edge-path {
    stroke-width: 2.5;
  }
  .react-flow__edge.animated path {
    animation-duration: 1.2s;
  }
  .react-flow__edge {
    transition: opacity 0.18s ease;
  }
  .react-flow__edge.loop-edge--muted {
    opacity: 0.11;
  }
  .react-flow__edge.loop-edge--active {
    opacity: 1;
  }
  .react-flow__edge:hover .react-flow__edge-path,
  .react-flow__edge.loop-edge--active .react-flow__edge-path {
    stroke-width: 3.1 !important;
    filter: drop-shadow(0 0 2px rgba(45, 72, 58, 0.3));
  }
  .react-flow__edge.loop-edge--active .react-flow__edge-text {
    font-size: 10px !important;
  }

  @media (prefers-reduced-motion: reduce) {
    *,
    *::before,
    *::after {
      animation: none !important;
      transition: none !important;
    }
  }
`;
